// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1445":"6ad137307078f208","3013":"16073cdf82756991"}[chunkId] + ".css";
};